import { type TermsConfig, TermsManagementPage } from "@/features/terms";

const APP_TERMS_CONFIG: TermsConfig = {
	type: "app",
	pageTitle: "こぺ利用規約管理",
	termTitle: "こぺ利用規約",
};

export default function AppTermsPage() {
	return <TermsManagementPage config={APP_TERMS_CONFIG} />;
}
